import React from "react";
import AmenityAccordianNew from "../../Molecules/AmenityAccordian/newIndex";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ProjectAmenitiesNew(_ref) {
  var _ref$amenties = _ref.amenties,
    amenties = _ref$amenties === void 0 ? [] : _ref$amenties,
    config = _ref.config,
    _ref$amenitiesLabel = _ref.amenitiesLabel,
    amenitiesLabel = _ref$amenitiesLabel === void 0 ? "Amenities" : _ref$amenitiesLabel;
  return /*#__PURE__*/_jsxs("div", {
    id: "amenities",
    className: " mt-8",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex flex-col",
      children: /*#__PURE__*/_jsx("h4", {
        className: "z-10 text-xl ".concat(config !== null && config !== void 0 && config.darkMode ? "text-primary" : "text-[#130E2F]", " my-2 font-bold ").concat((config === null || config === void 0 ? void 0 : config.fontTitle) || ""),
        children: amenitiesLabel
      })
    }), (amenties === null || amenties === void 0 ? void 0 : amenties.length) >= 1 && /*#__PURE__*/_jsx(AmenityAccordianNew, {
      projectAmenities: amenties,
      config: config
    })]
  });
}